export class ErrorLog {
    Name: string;
    LogType: string;
    Message: string;
    Stack: string;
    
  }